import PropTypes from 'prop-types';
import { Loader } from '../../../common/components';
import NoData from '../utils/no-data';
import DashboardGarphCardLayout from './graphLayout';
import PieGraph from './graphs/PieGraph';

const PieDataPreprocessing = (data) => {
  const processedData = { totalAmount: 0, segmentation: [] };
  data.forEach((service) => {
    const _service = { ...service };
    if (service.totalAmount && service.totalAmount > 0) {
      _service.isNegative = false;
      processedData.segmentation.push(_service);
      processedData.totalAmount += service.totalAmount;
    } else {
      _service.isNegative = true;
      _service.totalAmount = Math.abs(service.totalAmount);
      processedData.segmentation.push(_service);
      processedData.totalAmount += _service.totalAmount;
    }
  });
  return processedData;
};

function ARSegmentBreakdown({ id, data, loader }) {
  const processedData = PieDataPreprocessing(data.segmentation);
  const hasPieData = processedData.segmentation.some((service) => service.totalAmount > 0);
  return (
    <DashboardGarphCardLayout
      title={data.title}
      tooltip={data.tooltip}
      data={data}
      redirection={{
        ...data.redirection,
        enabled: data.segmentation.length && data.redirection.enabled,
      }}
    >
      {loader && <Loader />}
      {!loader && hasPieData && (
        <PieGraph
          id={id}
          data={{
            ...data,
            totalAmount: processedData.totalAmount,
            segmentation: processedData.segmentation,
          }}
        />
      )}
      {!loader && !hasPieData && <NoData />}
    </DashboardGarphCardLayout>
  );
}

ARSegmentBreakdown.propTypes = {
  id: PropTypes.string.isRequired,
  loader: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    totalAmount: PropTypes.number.isRequired,
    segmentation: PropTypes.shape([]).isRequired,
    redirection: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ARSegmentBreakdown;
